export default __webpack_public_path__ + "static/media/plants.21aae1be.png";